'use client';
import { clamp } from '@s7/utils';
import { isConvertibleColor } from '../validators/validators.js';
import { toRGBA } from '../toRGBA/toRGBA.js';

var mix = function(a, b, ratio) {
    return Math.floor(a * (1 - ratio) + b * ratio);
};
var blend = function(target, admixture, ratio, alphaBlend) {
    if (ratio === void 0) ratio = 0.5;
    if (alphaBlend === void 0) alphaBlend = "mix";
    if (!isConvertibleColor(target)) {
        return target;
    }
    var _toRGBA = toRGBA(target), r = _toRGBA.r, g = _toRGBA.g, b = _toRGBA.b, a = _toRGBA.a;
    var _toRGBA1 = toRGBA(admixture), _r = _toRGBA1.r, _g = _toRGBA1.g, _b = _toRGBA1.b;
    // Используем admixture, если target полностью прозрачен
    if (a === 0) {
        return "rgba(" + _r + "," + _g + "," + _b + "," + ratio + ")";
    }
    var alpha = alphaBlend === "mix" ? clamp(Math.round((a + ratio) * 100) / 100, [
        0,
        1
    ]) : ratio;
    return "rgba(" + mix(r, _r, ratio) + "," + mix(g, _g, ratio) + "," + mix(b, _b, ratio) + "," + alpha + ")";
};

export { blend };
